module.exports = __webpack_public_path__ + "static/media/company-logo-placeholder.52f0a2ae.png";